import { requests } from '../Common/HttpClient/HttpClient';

const { post, get, patch } = requests;

function login(email, password) {
    return post('/api/v1/Auth/login', { email, password });
}

function resetPassword(data, token) {
    return post('/api/Auth/resetPassword', { ...data, token });
}

function getProfile() {
    return get('/api/v1/Auth/profile');
}

function getVerificationMail() {
    return get('/api/Auth/sendVerifiacationMail');
}

function verifyMail(token) {
    return post('/api/Auth/verifyMail', { token });
}

function updateProfile(phoneNumber) {
    return patch('/api/v1/Auth/profile', { phoneNumber: `${phoneNumber}` });
}

function changePassword(currentPassword, newPassword, confirmNewPassword) {
    return patch('/api/v1/Auth/updatePassword', { currentPassword, newPassword, confirmNewPassword });
}

function forgotPassword(email) {
    return post('/api/Auth/forgotPassword', { email: `${email}` });
}

function refreshToken(token, refreshToken) {
    return post('/api/v1/Auth/refreshToken', { token, refreshToken });
}

const AuthAgent = {
    login,
    resetPassword,
    getProfile,
    getVerificationMail,
    verifyMail,
    updateProfile,
    changePassword,
    forgotPassword,
    refreshToken
};

export default AuthAgent;
